/**お知らせ掲載対象 */
export var InformationTarget;
(function (InformationTarget) {
    /**全契約者 */
    InformationTarget[InformationTarget["All"] = 1] = "All";
    /**担当店 */
    InformationTarget[InformationTarget["Department"] = 2] = "Department";
    /**物件 */
    InformationTarget[InformationTarget["Property"] = 3] = "Property";
    /**契約者 */
    InformationTarget[InformationTarget["Contractor"] = 4] = "Contractor";
    /**社内 */
    InformationTarget[InformationTarget["Company"] = 5] = "Company";
})(InformationTarget || (InformationTarget = {}));
/**ユーザ区分 */
export var UserKb;
(function (UserKb) {
    /**入居者 */
    UserKb[UserKb["Tenant"] = 1] = "Tenant";
    /**MT */
    UserKb[UserKb["Mt"] = 2] = "Mt";
})(UserKb || (UserKb = {}));
export var Weightid;
(function (Weightid) {
    /**重要 */
    Weightid[Weightid["weight"] = 1] = "weight";
})(Weightid || (Weightid = {}));
export var ResponseContent;
(function (ResponseContent) {
    /**肯定 */
    ResponseContent[ResponseContent["aggerr"] = 1] = "aggerr";
    /**否定 */
    ResponseContent[ResponseContent["negative"] = 2] = "negative";
    /**未回答 */
    ResponseContent[ResponseContent["notAnswered"] = 0] = "notAnswered";
})(ResponseContent || (ResponseContent = {}));
export var isAnswered;
(function (isAnswered) {
    /**未回答 */
    isAnswered[isAnswered["notAnswered"] = 0] = "notAnswered";
    /**回答済 */
    isAnswered[isAnswered["answered"] = 1] = "answered";
})(isAnswered || (isAnswered = {}));
export var ReadId;
(function (ReadId) {
    /**New */
    ReadId[ReadId["notRead"] = 1] = "notRead";
})(ReadId || (ReadId = {}));
export var HanyoKb;
(function (HanyoKb) {
    /** 証明書種別*/
    HanyoKb[HanyoKb["ShomeiPattern"] = 1] = "ShomeiPattern";
    /** 破損汚損項目 S君*/
    HanyoKb[HanyoKb["HasonItemSuper"] = 2] = "HasonItemSuper";
    /** 破損汚損項目 通常*/
    HanyoKb[HanyoKb["HasonItemDefault"] = 3] = "HasonItemDefault";
    /** 退去予定日入力範囲*/
    HanyoKb[HanyoKb["TaikyoDateRange"] = 4] = "TaikyoDateRange";
    /** アカウント利用期間*/
    HanyoKb[HanyoKb["AccountLimit"] = 5] = "AccountLimit";
    /** 鍵返却予定時間*/
    HanyoKb[HanyoKb["KeyReternTimeRange"] = 6] = "KeyReternTimeRange";
    /** トップページ項目*/
    HanyoKb[HanyoKb["TopPageItems"] = 7] = "TopPageItems";
    /** 解約通知案内種別*/
    HanyoKb[HanyoKb["KaiyakuTsuchiType"] = 8] = "KaiyakuTsuchiType";
    /** 退去ボタン表示期間*/
    HanyoKb[HanyoKb["TaikyoButtonDisplayTerm"] = 9] = "TaikyoButtonDisplayTerm";
    /** 解約精算種別*/
    HanyoKb[HanyoKb["SeisanType"] = 10] = "SeisanType";
    /** デジタルキー暗証番号*/
    HanyoKb[HanyoKb["DigitalKeyOriginalNo"] = 11] = "DigitalKeyOriginalNo";
    /** 口座伏字設定*/
    HanyoKb[HanyoKb["BankAccountHide"] = 12] = "BankAccountHide";
    /** 鍵渡名称区分*/
    HanyoKb[HanyoKb["KeyReturnName"] = 13] = "KeyReturnName";
    /** 退去申請の流れ*/
    HanyoKb[HanyoKb["TaikyoFlow"] = 14] = "TaikyoFlow";
    /**掲載対象 */
    HanyoKb[HanyoKb["TargetType"] = 15] = "TargetType";
    /**入居状況 */
    HanyoKb[HanyoKb["NyukyoKb"] = 16] = "NyukyoKb";
    /**お知らせメール通知送信時刻(時) */
    HanyoKb[HanyoKb["EmailNotificationHour"] = 17] = "EmailNotificationHour";
    /**お知らせメール通知送信時刻（分） */
    HanyoKb[HanyoKb["EmailNotificationMinute"] = 18] = "EmailNotificationMinute";
    /**契約区分 */
    HanyoKb[HanyoKb["UserKb"] = 19] = "UserKb";
    /**お知らせ重要 */
    HanyoKb[HanyoKb["InformationWeight"] = 21] = "InformationWeight";
    /**回答状況 */
    HanyoKb[HanyoKb["ResponsesKbn"] = 22] = "ResponsesKbn";
    /**回答内容 */
    HanyoKb[HanyoKb["ResponsesContentKbn"] = 23] = "ResponsesContentKbn";
    /**お知らせ確認 */
    HanyoKb[HanyoKb["InformationRead"] = 24] = "InformationRead";
    /**口座種別 */
    HanyoKb[HanyoKb["KouzaSb"] = 29] = "KouzaSb";
    /**MMA情報 */
    HanyoKb[HanyoKb["MmaInfo"] = 33] = "MmaInfo";
    /** エリア識別コード*/
    HanyoKb[HanyoKb["AreaCode"] = 53] = "AreaCode";
    /** 対象操作*/
    HanyoKb[HanyoKb["TargetOperation"] = 54] = "TargetOperation";
})(HanyoKb || (HanyoKb = {}));
/**お知らせ詳細画面遷移前の画面 */
export var InformationDetailBeforeRouteKbn;
(function (InformationDetailBeforeRouteKbn) {
    /**トップページ */
    InformationDetailBeforeRouteKbn[InformationDetailBeforeRouteKbn["TopPage"] = 1] = "TopPage";
    /** お知らせ一覧*/
    InformationDetailBeforeRouteKbn[InformationDetailBeforeRouteKbn["InformationList"] = 2] = "InformationList";
    /** お知らせ一覧（管理者）*/
    InformationDetailBeforeRouteKbn[InformationDetailBeforeRouteKbn["AdminInformationList"] = 3] = "AdminInformationList";
    /** 入居者詳細*/
    InformationDetailBeforeRouteKbn[InformationDetailBeforeRouteKbn["NyukyoshaDetail"] = 4] = "NyukyoshaDetail";
})(InformationDetailBeforeRouteKbn || (InformationDetailBeforeRouteKbn = {}));
export var JokyoKb;
(function (JokyoKb) {
    /**入居中 */
    JokyoKb[JokyoKb["MoveIn"] = 3] = "MoveIn";
    /**退去申請中 */
    JokyoKb[JokyoKb["CancelRequest"] = 4] = "CancelRequest";
    /**清算済 */
    JokyoKb[JokyoKb["Cleared"] = 5] = "Cleared";
})(JokyoKb || (JokyoKb = {}));
/** 個人 or 法人 */
export var userType;
(function (userType) {
    /**入居者 */
    userType[userType["Kojin"] = 0] = "Kojin";
    /**MT */
    userType[userType["hojin"] = 1] = "hojin";
})(userType || (userType = {}));
export var RoomSb;
(function (RoomSb) {
    /** 部屋 */
    RoomSb[RoomSb["Room"] = 1] = "Room";
    /** 駐車場 */
    RoomSb[RoomSb["Parking"] = 2] = "Parking";
    /** 店舗 */
    RoomSb[RoomSb["Shop"] = 3] = "Shop";
    /** 事務所 */
    RoomSb[RoomSb["Office"] = 4] = "Office";
    /** 賃家 */
    RoomSb[RoomSb["RentalHouse"] = 5] = "RentalHouse";
    /** その他 */
    RoomSb[RoomSb["Other"] = 6] = "Other";
})(RoomSb || (RoomSb = {}));
export var SelectRoomSb;
(function (SelectRoomSb) {
    /** 部屋 */
    SelectRoomSb[SelectRoomSb["Room"] = 1] = "Room";
    /** 駐車場 */
    SelectRoomSb[SelectRoomSb["Parking"] = 2] = "Parking";
    /** 部屋 + 駐車場 */
    SelectRoomSb[SelectRoomSb["RoomAndParking"] = 3] = "RoomAndParking";
})(SelectRoomSb || (SelectRoomSb = {}));
/** 入居ステータス */
export var NyukyoStatus;
(function (NyukyoStatus) {
    /** 入居中 */
    NyukyoStatus[NyukyoStatus["CurrentlyMovingIn"] = 0] = "CurrentlyMovingIn";
    /** 退去申請中 */
    NyukyoStatus[NyukyoStatus["Request"] = 1] = "Request";
    /** 退去承認 */
    NyukyoStatus[NyukyoStatus["Approval"] = 2] = "Approval";
    /** 解約通知返信 */
    NyukyoStatus[NyukyoStatus["NotificationReply"] = 3] = "NotificationReply";
    /** 解約通知承認 */
    NyukyoStatus[NyukyoStatus["NotificationApproval"] = 4] = "NotificationApproval";
    /** 仮清算 */
    NyukyoStatus[NyukyoStatus["ProvisionalLiquidation"] = 5] = "ProvisionalLiquidation";
    /** 清算済み */
    NyukyoStatus[NyukyoStatus["Cleared"] = 6] = "Cleared";
})(NyukyoStatus || (NyukyoStatus = {}));
/** SMS通知種別 */
export var SmsNotificationType;
(function (SmsNotificationType) {
    /** アカウント発行 */
    SmsNotificationType[SmsNotificationType["AccountIssuance"] = 1] = "AccountIssuance";
    /** 証明書申請 */
    SmsNotificationType[SmsNotificationType["ShomeiEntry"] = 2] = "ShomeiEntry";
    /** 退去申請 */
    SmsNotificationType[SmsNotificationType["TaikyoEntry"] = 3] = "TaikyoEntry";
    /** パスワード変更 */
    SmsNotificationType[SmsNotificationType["PasswordChange"] = 4] = "PasswordChange";
})(SmsNotificationType || (SmsNotificationType = {}));
/** 証明書種別 */
export var ShomeiSb;
(function (ShomeiSb) {
    /** 車庫証明書 */
    ShomeiSb[ShomeiSb["Shako"] = 1] = "Shako";
    /** 退去証明書 */
    ShomeiSb[ShomeiSb["Taikyo"] = 2] = "Taikyo";
    /** 居住証明書 */
    ShomeiSb[ShomeiSb["Kyoju"] = 3] = "Kyoju";
    /** 賃料支払証明書 */
    ShomeiSb[ShomeiSb["Chinryo"] = 4] = "Chinryo";
})(ShomeiSb || (ShomeiSb = {}));
/** 車庫証明 契約者・使用者区分 */
export var ShakoKeiyakushaToShiyoushaKbn;
(function (ShakoKeiyakushaToShiyoushaKbn) {
    /** 契約者と使用者同じ */
    ShakoKeiyakushaToShiyoushaKbn[ShakoKeiyakushaToShiyoushaKbn["same"] = 1] = "same";
    /** 契約者と使用者異なる */
    ShakoKeiyakushaToShiyoushaKbn[ShakoKeiyakushaToShiyoushaKbn["different"] = 2] = "different";
})(ShakoKeiyakushaToShiyoushaKbn || (ShakoKeiyakushaToShiyoushaKbn = {}));
export var FileFetchKb;
(function (FileFetchKb) {
    /** レガナム */
    FileFetchKb[FileFetchKb["Reganam"] = 1] = "Reganam";
    /** ストレージ */
    FileFetchKb[FileFetchKb["Storage"] = 2] = "Storage";
    /** サーバー */
    FileFetchKb[FileFetchKb["Server"] = 3] = "Server";
})(FileFetchKb || (FileFetchKb = {}));
export var FileCode;
(function (FileCode) {
    /** お住まいの物件に関するご案内ファイル */
    FileCode[FileCode["NyukyoInfoPropertyFile"] = 1] = "NyukyoInfoPropertyFile";
    /** 入居者セットファイル */
    FileCode[FileCode["NyukyoInfoSetFile"] = 2] = "NyukyoInfoSetFile";
    /** ログイン情報ファイル */
    FileCode[FileCode["LoginFile"] = 3] = "LoginFile";
    /** 解約精算書 */
    FileCode[FileCode["KaiyakuSeisanFile"] = 4] = "KaiyakuSeisanFile";
    /** お知らせ添付ファイル */
    FileCode[FileCode["InformationFile"] = 5] = "InformationFile";
    /** 破損汚損申告書 */
    FileCode[FileCode["TaikyoHasonFile"] = 6] = "TaikyoHasonFile";
    /** その他ファイル*/
    FileCode[FileCode["TaikyoOthersFile"] = 7] = "TaikyoOthersFile";
    /** 入居者専用ガイドファイル*/
    FileCode[FileCode["NyukyoInfoCommonFile"] = 8] = "NyukyoInfoCommonFile";
    /** 破損汚損テンプレートファイル*/
    FileCode[FileCode["TaikyoHasonTemplateFile"] = 9] = "TaikyoHasonTemplateFile";
    /** 発行書式指定ファイル*/
    FileCode[FileCode["ShomeiFile"] = 10] = "ShomeiFile";
})(FileCode || (FileCode = {}));
/** 退去理由区分 */
export var TaikyoRiyuKb;
(function (TaikyoRiyuKb) {
    /**就職・転職 */
    TaikyoRiyuKb[TaikyoRiyuKb["EmploymentOrCareerChange"] = 0] = "EmploymentOrCareerChange";
    /** 転勤 */
    TaikyoRiyuKb[TaikyoRiyuKb["JobTransfer"] = 1] = "JobTransfer";
    /** 結婚 */
    TaikyoRiyuKb[TaikyoRiyuKb["Marriage"] = 2] = "Marriage";
    /** 購入 */
    TaikyoRiyuKb[TaikyoRiyuKb["Purchase"] = 3] = "Purchase";
    /** 独立（世帯分離） */
    TaikyoRiyuKb[TaikyoRiyuKb["Independence"] = 4] = "Independence";
    /** 親族と同居 */
    TaikyoRiyuKb[TaikyoRiyuKb["LiveWithRelatives"] = 5] = "LiveWithRelatives";
    /** 不満・トラブル */
    TaikyoRiyuKb[TaikyoRiyuKb["DissatisfactionOrTrouble"] = 6] = "DissatisfactionOrTrouble";
    /** その他 */
    TaikyoRiyuKb[TaikyoRiyuKb["Other"] = 99] = "Other";
})(TaikyoRiyuKb || (TaikyoRiyuKb = {}));
/** 連絡先区分 */
export var RenrakuKb;
(function (RenrakuKb) {
    /** 法人 */
    RenrakuKb[RenrakuKb["Hojin"] = 1] = "Hojin";
    /** 入居者 */
    RenrakuKb[RenrakuKb["Nyukyosha"] = 2] = "Nyukyosha";
    /** その他 */
    RenrakuKb[RenrakuKb["Other"] = 9] = "Other";
})(RenrakuKb || (RenrakuKb = {}));
/** 鍵封筒送付先区分 */
export var KeyReturnAdrKb;
(function (KeyReturnAdrKb) {
    /** 法人 */
    KeyReturnAdrKb[KeyReturnAdrKb["Hojin"] = 1] = "Hojin";
    /** 入居者 */
    KeyReturnAdrKb[KeyReturnAdrKb["Nyukyosha"] = 2] = "Nyukyosha";
    /** その他 */
    KeyReturnAdrKb[KeyReturnAdrKb["Other"] = 9] = "Other";
})(KeyReturnAdrKb || (KeyReturnAdrKb = {}));
/** 鍵名称区分 */
export var KeyReturnNameKb;
(function (KeyReturnNameKb) {
    /** 立会希望日時  */
    KeyReturnNameKb[KeyReturnNameKb["PreferredAttendanceDatetime"] = 1] = "PreferredAttendanceDatetime";
    /** 鍵封筒投函予定日  */
    KeyReturnNameKb[KeyReturnNameKb["KeyEnvelopePostingDate"] = 2] = "KeyEnvelopePostingDate";
    /** 鍵返却予定日時  */
    KeyReturnNameKb[KeyReturnNameKb["KeyReturnScheduledDatetime"] = 3] = "KeyReturnScheduledDatetime";
    /** 明渡日  */
    KeyReturnNameKb[KeyReturnNameKb["HandoverDate"] = 4] = "HandoverDate";
    /** 退去予定日  */
    KeyReturnNameKb[KeyReturnNameKb["TaikyoScheduledDate"] = 99] = "TaikyoScheduledDate";
})(KeyReturnNameKb || (KeyReturnNameKb = {}));
/** 最新情報処理結果ステータス */
export var LatestResultStatus;
(function (LatestResultStatus) {
    /** 成功(レガナム取得) */
    LatestResultStatus[LatestResultStatus["Success"] = 1] = "Success";
    /** 成功（DB取得） */
    LatestResultStatus[LatestResultStatus["Fallback"] = 2] = "Fallback";
    /** 失敗 */
    LatestResultStatus[LatestResultStatus["Error"] = 99] = "Error";
})(LatestResultStatus || (LatestResultStatus = {}));
/** 最新情報処理ステータス */
export var LatestAsyncStatus;
(function (LatestAsyncStatus) {
    /** 処理前 */
    LatestAsyncStatus[LatestAsyncStatus["NotStarted"] = 0] = "NotStarted";
    /** 処理中 */
    LatestAsyncStatus[LatestAsyncStatus["Processing"] = 1] = "Processing";
    /** 成功 */
    LatestAsyncStatus[LatestAsyncStatus["Success"] = 2] = "Success";
    /** 失敗 */
    LatestAsyncStatus[LatestAsyncStatus["Error"] = 3] = "Error";
})(LatestAsyncStatus || (LatestAsyncStatus = {}));
/** 画面ID */
export var PageID;
(function (PageID) {
    PageID["top"] = "UNY0000001";
    PageID["mailaddressChange"] = "UNY0000002";
    PageID["mailaddressCheck"] = "UNY0000003";
    PageID["mailaddressChangeComplete"] = "UNY0000004";
    PageID["passwordChange"] = "UNY0000005";
    PageID["passwordChangeComplete"] = "UNY0000006";
    PageID["termsOfConfirm"] = "UNY0000007";
    PageID["resync"] = "UNY0000008";
    PageID["adminPasswordChange"] = "UNY0000009";
    PageID["mailaddressConfig"] = "UNY0000010";
    PageID["informationList"] = "INF0000001";
    PageID["adminInformationList"] = "INF0000002";
    PageID["informationEdit"] = "INF0000003";
    PageID["informationDetail"] = "INF0000004";
    PageID["keiyakushaList"] = "ACC0000001";
    PageID["accountEdit"] = "ACC0000002";
    PageID["keiyaku"] = "KEI0000001";
    PageID["shinjoshoEdit"] = "KEI0000002";
    PageID["seikyu"] = "KEI0000003";
    PageID["nyukyo"] = "KEI0000004";
    PageID["nyukyoshaList"] = "TEN0000001";
    PageID["nyukyoshaDetail"] = "TEN0000002";
    PageID["taikyo"] = "TAI0000001";
    PageID["taikyoRoomList"] = "TAI0000002";
    PageID["taikyoFlowGuide"] = "TAI0000003";
    PageID["taikyoNotificationFlowGuide"] = "TAI0000004";
    PageID["taikyoPrecaution"] = "TAI0000005";
    PageID["taikyoEntry"] = "TAI0000006";
    PageID["taikyoEntryCheck"] = "TAI0000007";
    PageID["taikyoNotificationEntry"] = "TAI0000008";
    PageID["taikyoNotificationEntryCheck"] = "TAI0000009";
    PageID["taikyoEntryComplete"] = "TAI0000010";
    PageID["taikyoAppliedList"] = "TAI0000011";
    PageID["kaiyakuGuide"] = "KAI0000001";
    PageID["kaiyakuEntry"] = "KAI0000002";
    PageID["kaiyakuEntryHason"] = "KAI0000003";
    PageID["kaiyakuEntryCheck"] = "KAI0000004";
    PageID["kaiyakuEntryComplete"] = "KAI0000005";
    PageID["taikyoComplete"] = "KAI0000006";
    PageID["kaiyakuSeisan"] = "KAI0000007";
    PageID["shomeiList"] = "SHO0000001";
    PageID["shomeiRoomList"] = "SHO0000002";
    PageID["shomeiPrecautions"] = "SHO0000003";
    PageID["shomeiShinsei"] = "SHO0000004";
    PageID["shomeiShinseiEntryCheck"] = "SHO0000005";
    PageID["shomeiEntryComplete"] = "SHO0000006";
})(PageID || (PageID = {}));
